import { ModuleFE_Pathway, ModuleFE_PathwayState } from '../_entity.js';
import { DBDef_Action, DBDef_Pathway, DBDef_PathwayState, DBDef_PathwayTransition, } from '@app/pathway-shared';
const conflictResolutionItem_Pathway = {
    dbKey: DBDef_Pathway.dbKey,
    collectionRenderer: () => 'Pathways',
    renderer: pathway => pathway.label,
    filterMapper: pathway => [pathway.label],
};
const conflictResolutionItem_PathwayState = {
    dbKey: DBDef_PathwayState.dbKey,
    collectionRenderer: () => 'Pathway States',
    renderer: state => state.name,
    filterMapper: state => [state.name],
};
const getTransitionLabel = (transition) => {
    const originState = ModuleFE_PathwayState.cache.unique(transition.sourceId);
    const targetState = ModuleFE_PathwayState.cache.unique(transition.targetId);
    const pathway = ModuleFE_Pathway.cache.unique(transition.pathwayIds[0]);
    if (!originState || !targetState || !pathway)
        return;
    return `${pathway.label}: ${originState.name} > ${targetState.name}`;
};
const conflictResolutionItem_PathwayTransition = {
    dbKey: DBDef_PathwayTransition.dbKey,
    collectionRenderer: () => 'Pathway Transitions',
    renderer: transition => getTransitionLabel(transition),
    filterMapper: transition => {
        const label = getTransitionLabel(transition);
        return label ? [label] : [];
    },
};
const conflictResolutionItem_Action = {
    dbKey: DBDef_Action.dbKey,
    collectionRenderer: () => 'Actions',
    renderer: action => action.name,
    filterMapper: action => [action.name],
};
export const ConflictResolutionItemGroup_Pathway = [
    conflictResolutionItem_Pathway,
    conflictResolutionItem_PathwayState,
    conflictResolutionItem_PathwayTransition,
    conflictResolutionItem_Action,
];
//# sourceMappingURL=conflict-resolution-items.js.map